"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NoOptionsWrapper = exports.buildOptionRenderer = exports.defaultRenderOptions = exports.defaultGetOptionLabel = exports.getHighlightParts = void 0;

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

var _match = _interopRequireDefault(require("autosuggest-highlight/match"));

var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _TextField = _interopRequireDefault(require("../../atoms/TextField"));

var _misc = require("../../misc");

var _styles = _interopRequireDefault(require("./styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconMargins = {
  standard: {
    clear: (0, _misc.pxToRem)(-16),
    search: (0, _misc.pxToRem)(-12)
  },
  outlined: {
    clear: 0,
    search: (0, _misc.pxToRem)(3)
  },
  filled: {
    clear: (0, _misc.pxToRem)(-16),
    search: (0, _misc.pxToRem)(-12)
  }
};
var SearchIcon = /*#__PURE__*/(0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "ComboBox__SearchIcon"
})(["padding:", ";font-size:", ";color:", ";margin-top:", ";"], (0, _misc.pxToRem)(4), (0, _misc.pxToRem)(23), function (props) {
  return props.theme.palette.grey[300];
}, function (props) {
  return iconMargins[props.variant].search;
});

var Icons = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ComboBox__Icons"
})(["display:flex;.MuiAutocomplete-clearIndicator{padding:0;margin-top:", ";.MuiIconButton-label{padding:", ";svg{font-size:", ";color:", ";}}}"], function (props) {
  return iconMargins[props.variant].clear;
}, (0, _misc.pxToRem)(4), (0, _misc.pxToRem)(28), function (props) {
  return props.theme.palette.grey[300];
});

var Autocomplete = /*#__PURE__*/(0, _styledComponents["default"])(_lab.Autocomplete).withConfig({
  displayName: "ComboBox__Autocomplete"
})([".MuiAutocomplete-inputRoot{padding-left:", ";padding-right:", ";}"], (0, _misc.pxToRem)(8), (0, _misc.pxToRem)(8));
var TextField = /*#__PURE__*/(0, _styledComponents["default"])(_TextField["default"]).withConfig({
  displayName: "ComboBox__TextField"
})(["width:", ";"], function (props) {
  return props.fullWidth ? '100%' : (0, _misc.pxToRem)(props.width);
});

var HighlightedText = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "ComboBox__HighlightedText"
})(["font-weight:", ";"], function (props) {
  return props.highlight ? props.theme.typography.fontWeightBold : props.theme.typography.fontWeightRegular;
});

var getHighlightParts = function getHighlightParts(option, value) {
  var matches = (0, _match["default"])(option, value);
  var parts = (0, _parse["default"])(option, matches);
  return parts;
};

exports.getHighlightParts = getHighlightParts;

var defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return option.title;
}; // Return JSX for the option with highlighting based on inputValue


exports.defaultGetOptionLabel = defaultGetOptionLabel;

var defaultRenderOptions = function defaultRenderOptions(option, _ref) {
  var inputValue = _ref.inputValue;
  var parts = getHighlightParts(option, inputValue);
  return _react["default"].createElement("div", null, parts.map(function (part, index) {
    return _react["default"].createElement(HighlightedText, {
      key: index,
      highlight: part.highlight
    }, part.text);
  }));
}; // Build the renderer function and return it


exports.defaultRenderOptions = defaultRenderOptions;

var buildOptionRenderer = function buildOptionRenderer(getOptionLabel) {
  return function (option, inputValue) {
    return defaultRenderOptions(getOptionLabel(option), inputValue);
  };
}; // Prevent the noOptions paper from closing when clicking on any of the child components


exports.buildOptionRenderer = buildOptionRenderer;

var NoOptionsWrapper = function NoOptionsWrapper(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return _react["default"].createElement(_core.Paper, _extends({
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, rest), children);
};

exports.NoOptionsWrapper = NoOptionsWrapper;

var LegoComboBox = function LegoComboBox(_ref3) {
  var fullWidth = _ref3.fullWidth,
      width = _ref3.width,
      inputProps = _ref3.inputProps,
      props = _objectWithoutProperties(_ref3, ["fullWidth", "width", "inputProps"]);

  var variant = props.variant,
      label = props.label,
      getOptionLabel = props.getOptionLabel;
  var memoizedOptionRenderer = (0, _react.useMemo)(function () {
    return buildOptionRenderer(getOptionLabel);
  }, [buildOptionRenderer, getOptionLabel]);
  var memoizedEndAdornment = (0, _react.useCallback)(function (params) {
    var ClearIcon = function ClearIcon() {
      return params.InputProps.endAdornment.props.children && params.InputProps.endAdornment.props.children[0];
    };

    return _react["default"].createElement(Icons, {
      variant: variant
    }, _react["default"].createElement(ClearIcon, null), _react["default"].createElement(SearchIcon, {
      variant: variant,
      icon: "search",
      fontSize: "default"
    }));
  }, [variant, Icons]);
  var memoizedRenderInput = (0, _react.useCallback)(function (params) {
    var endAdornment = memoizedEndAdornment(params);
    return _react["default"].createElement(TextField, _extends({
      margin: "normal",
      label: label,
      variant: variant,
      fullWidth: fullWidth,
      width: width
    }, inputProps, params, {
      InputProps: _objectSpread({}, params.InputProps, {
        endAdornment: endAdornment
      })
    }));
  }, [label, variant, fullWidth, width, inputProps]);
  return _react["default"].createElement(Autocomplete, _extends({
    autoComplete: true,
    autoHighlight: true,
    clearOnEscape: true,
    renderOption: memoizedOptionRenderer,
    PaperComponent: NoOptionsWrapper,
    renderInput: memoizedRenderInput
  }, props));
};

LegoComboBox.defaultProps = {
  label: '',
  options: [],
  width: 320,
  fullWidth: false,
  variant: 'standard',
  getOptionLabel: defaultGetOptionLabel,
  inputProps: {}
};
LegoComboBox.propTypes = {
  label: _propTypes["default"].string,
  options: _propTypes["default"].array,
  width: _propTypes["default"].number,
  fullWidth: _propTypes["default"].bool,
  variant: _propTypes["default"].string,
  getOptionLabel: _propTypes["default"].func,
  inputProps: _propTypes["default"].object
};

var _default = (0, _styles["default"])(LegoComboBox);

exports["default"] = _default;